import {
  SessionStorage,
  JSONTransform,
} from '@flight-workspace/common-client/src/util/storage';
import { IKeyAnyValue } from 'common/types';

const domesticFilterStorage = new SessionStorage<IKeyAnyValue>(
  'domesticFilters',
  new JSONTransform(),
);

export default domesticFilterStorage;
